import moment from "moment";
import { useQuery } from "react-query";
import { AcademicUser, Role, SimpleViewAcademicUserDTO } from "../Api";
import { getRolesForUser, getUserById } from "../Requests/academic-user-requests";
import { getSubject } from "../Requests/subject-requests";

const jwt = require('jsonwebtoken');

export function getUserId(): any {
    return jwt.decode(localStorage.getItem('token'))?.sub;
}

export function getTokenExpire(): any {
    return jwt.decode(localStorage.getItem('token'))?.exp;
}

export function isUserLogged(): boolean {
    return localStorage.getItem('token') != null;
}

export function logout(isAcademic: boolean): void {
    localStorage.clear();

    // if (isAcademic) {
    //     window.location.href = `${process.env.REACT_APP_AUTH_API_URL}/auth?clientAction=logout&clientName=https://${process.env.REACT_APP_DOMAIN}/`;
    // }
};

export const capitalizeFirst = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export default function useRoles() {
    return useQuery(["getRoles"], () => isUserLogged() ? getRolesForUser() : [], { refetchOnWindowFocus: false });
};

export const useIsAdmin = () => {
    let roles = useRoles();
    return roles.data?.includes(Role.Admin) || roles.data?.includes(Role.Vicerector) || roles.data?.includes(Role.Rector);
};

export const useIsDean = () => {
    let roles = useRoles();
    return roles.data?.includes(Role.Dean) || roles.data?.includes(Role.Vicedean);
};

// Facultatea decanului vine din departamentul lui (la fel ca in backend, IsDeanOf).
export const useCurrentUserFacultyId = () => {
    return useUserData().data?.department?.facultyId;
};

// Decan/prodecan al facultatii date. useIsDean() verifica doar rolul, nu si facultatea.
export const useIsDeanOfFaculty = (facultyId?: string | null) => {
    const isDean = useIsDean();
    const userFacultyId = useCurrentUserFacultyId();
    return !!isDean && !!facultyId && facultyId === userFacultyId;
};

export const useIsFacultyAdmin = () => {
    return useRoles().data?.includes(Role.FacultyAdmin);
};

export function useUserData() {
    return useQuery(["academicUserById"], () => isUserLogged() ? getUserById(getUserId()) : null, { refetchOnWindowFocus: false });
};

export const useIsDepartmentDirector = (departmentId: string) => {
    let userDepartmentId = useUserData().data?.departmentId;
    return useRoles().data?.includes(Role.DepartmentDirector) && userDepartmentId === departmentId;
};

export const isProgramSupervisor = (programSupervisors?: AcademicUser[] | null) => {
    return (programSupervisors ?? []).some(supervisor => supervisor.id === getUserId());
};

export const useIsGenericDepartmentDirector = () => {
    return useRoles().data?.includes(Role.DepartmentDirector);
};

export const useIsDirectorCsud = () => {
    return useRoles().data?.includes(Role.DirectorCsud);
};

export const useIsTitular = (subjectId: string) => {
    let subject = useQuery(["getSubject", subjectId], () => isUserLogged() ? getSubject(subjectId) : undefined, { refetchOnWindowFocus: false });
    return subject.data?.courseCoordinators?.find(e => e.id === getUserId());
};

export const useIsLabTitular = (subjectId: string) => {
    let subject = useQuery(["getSubject", subjectId], () => isUserLogged() ? getSubject(subjectId) : undefined, { refetchOnWindowFocus: false });
    return subject.data?.labCoordinators?.find(e => e.id === getUserId());
};

export function useSubject(subjectId: string) {
    let subject = useQuery(["getSubject", subjectId], () => isUserLogged() ? getSubject(subjectId) : undefined, { refetchOnWindowFocus: false });
    return subject.data;
};

export const getKey = (record: SimpleViewAcademicUserDTO) => {
    return record.id!;
}

export const getAllKeys = (filterItems: any[]) => {
    const keys: any[] = [];

    filterItems.forEach((filter) => {
        keys.push(filter.key);

        filter.children.forEach((filterItem: any) => {
            keys.push(filterItem.key.split("@")[1]);
        });
    });

    return keys;
};

export function geti18nLanguage(): any {
    return localStorage.getItem('i18nextLng');
}

export const addMonths = (date: Date, months: number): moment.Moment => {
    const newDate = moment(date);
    newDate.add(months, "months");

    return newDate;
};